import { createSelector } from 'reselect'
import { excludeNullOrUndefined } from 'checkout/utils'
import { sum } from 'lib/array/arrayUtils'
import { getLuxPlusBreakdownView, getSubscriptionJoinItemView } from 'checkout/selectors/view/luxPlusSubscription'

export const getLuxPlusSubscriptionTotals = createSelector(
  (state: App.State) => getLuxPlusBreakdownView(state),
  (viewWithStatus): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const definedItems = viewWithStatus.data.filter(excludeNullOrUndefined)
    return {
      hasRequiredData: viewWithStatus.hasRequiredData,
      data: {
        price: sum(definedItems, itemView => (itemView.price ?? 0)),
        value: sum(definedItems, itemView => (itemView.price ?? 0)),
        memberPrice: 0,
        surcharge: 0,
        taxesAndFees: 0,
        memberValue: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)

export const getSubscriptionJoinFeeTotals = createSelector(
  (state: App.State) => getSubscriptionJoinItemView(state),
  (view): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    return {
      hasRequiredData: true,
      data: {
        price: sum(view.data, view => view.totals.price),
        value: sum(view.data, view => view.totals.value || view.totals.price),
        memberPrice: 0,
        taxesAndFees: 0,
        surcharge: 0,
        memberValue: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)
